module.exports = {
      id: "islide-icon-1-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#islide-icon-1-usage",
      toString: function () {
        return this.url;
      }
    }